import { render, staticRenderFns } from "./OrganizationProfiler.vue?vue&type=template&id=d8866a4e&scoped=true&"
import script from "./OrganizationProfiler.vue?vue&type=script&lang=js&"
export * from "./OrganizationProfiler.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d8866a4e",
  null
  
)

export default component.exports